// extracted by mini-css-extract-plugin
export default {"w100":"CopyReportDefinitionModal_w100__C6FDa"};